module.exports = __webpack_public_path__ + "static/media/img_17.27868eec.JPG";